import React, { ReactNode, createContext, useContext, useState } from 'react';
import { EventReportAttributes } from '@loyalty/shared-common/event-processing-api-client';

export interface IEventReportContext {
  selectedReport: EventReportAttributes | undefined;
  setSelectedReport: (report: EventReportAttributes | undefined) => void;
}

export const EventReportsContext = createContext<IEventReportContext>({} as any);

export function useEventReports() {
  return useContext(EventReportsContext);
}

export function EventReportsProvider({ children }: { children: ReactNode }) {
  const [selectedReport, setSelectedReport] = useState<EventReportAttributes | undefined>();

  const context = {
    selectedReport,
    setSelectedReport,
  };

  return <EventReportsContext.Provider value={context}>{children}</EventReportsContext.Provider>;
}
